import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import PaymentActions, { MODAL_STAGES } from '~redux/payment';

import ConnectsExplanation from '../explanation';

import Request from './request';

import './style.scss';

// The customer is first told why a subscription is needed, and only reaches the
// payment modal after choosing to continue, so the explanation and the purchase
// never share a screen.
const PaymentRequestModal = () => {
  const dispatch = useDispatch();

  const { isRequestModalVisible, modalStage } = useSelector((state) => state.payment);

  const hide = useCallback(() => {
    dispatch(PaymentActions.toggleRequestModal(false));
    dispatch(PaymentActions.setModalData(null, null));
  });

  const continueToPayment = useCallback(() => {
    dispatch(PaymentActions.showPaymentStep());
  });

  if (!isRequestModalVisible) {
    return null;
  }

  return modalStage === MODAL_STAGES.payment ? (
    <Request onClose={hide} />
  ) : (
    <ConnectsExplanation onContinue={continueToPayment} onClose={hide} />
  );
};

export default PaymentRequestModal;
